var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-alert',{style:({ 'margin-bottom': _vm.marginBottom + 'px !important' }),attrs:{"dense":"","type":_vm.type,"prominent":_vm.large,"outlined":"","color":_vm.color,"icon":_vm.icon}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }